import { IPlanFactBudget } from "./types";

export const extractPlanFactBudget = (x: Pick<IPlanFactBudget, "budget" | "plan" | "fact"> | null) => ({
  budget: x?.budget ?? "",
  plan: x?.plan ?? "",
  fact: x?.fact ?? "",
});
